// @flow

import { applyCap } from "./score-caps";

export function findAverageWPSScore(distance: number, betType: string) {
  for (var i = 0; i < averageWPSScores.length; i++) {
    var averageWPSScore = averageWPSScores[i];
    var total = totalScore(averageWPSScore, betType);
    if (total >= distance) {
      return averageWPSScore;
    }
  }
  return averageWPSScores[averageWPSScores.length - 1];
}

export function totalScore(averageWPSScore: AverageWPSScore, betType: string) {
  return betType
    .split("")
    .map(type => applyCap(averageWPSScore[type], type))
    .reduce((a, b) => a + b);
}

type AverageWPSScore = {
  odds: string,
  W: number,
  P: number,
  S: number
};

const averageWPSScores: Array<AverageWPSScore> = [
  {
    "odds": "1-9",
    "W": 2.1,
    "P": 2.1,
    "S": 2.1
  },
  {
    "odds": "2-5",
    "W": 2.6,
    "P": 2.2,
    "S": 2.1
  },
  {
    "odds": "1-2",
    "W": 3,
    "P": 2.4,
    "S": 2.2
  },
  {
    "odds": "3-5",
    "W": 3.2,
    "P": 2.4,
    "S": 2.2
  },
  {
    "odds": "4-5",
    "W": 3.6,
    "P": 2.6,
    "S": 2.2
  },
  {
    "odds": "1-1",
    "W": 4,
    "P": 2.8,
    "S": 2.4
  },
  {
    "odds": "6-5",
    "W": 4.4,
    "P": 3,
    "S": 2.4
  },
  {
    "odds": "7-5",
    "W": 4.8,
    "P": 3,
    "S": 2.4
  },
  {
    "odds": "3-2",
    "W": 5,
    "P": 3.2,
    "S": 2.6
  },
  {
    "odds": "8-5",
    "W": 5.2,
    "P": 3.2,
    "S": 2.6
  },
  {
    "odds": "9-5",
    "W": 5.6,
    "P": 3.4,
    "S": 2.6
  },
  {
    "odds": "2-1",
    "W": 6.4,
    "P": 3.6,
    "S": 2.8
  },
  {
    "odds": "5-2",
    "W": 7.4,
    "P": 4,
    "S": 3
  },
  {
    "odds": "3-1",
    "W": 8.4,
    "P": 4.2,
    "S": 3.2
  },
  {
    "odds": "7-2",
    "W": 9.4,
    "P": 4.6,
    "S": 3.4
  },
  {
    "odds": "4-1",
    "W": 10.4,
    "P": 5,
    "S": 3.4
  },
  {
    "odds": "9-2",
    "W": 11.4,
    "P": 5.4,
    "S": 3.6
  },
  {
    "odds": "5-1",
    "W": 12.8,
    "P": 5.8,
    "S": 3.8
  },
  {
    "odds": "6-1",
    "W": 14.8,
    "P": 6.6,
    "S": 4.2
  },
  {
    "odds": "7-1",
    "W": 16.8,
    "P": 7.2,
    "S": 4.6
  },
  {
    "odds": "8-1",
    "W": 18.8,
    "P": 7.8,
    "S": 4.8
  },
  {
    "odds": "9-1",
    "W": 20.8,
    "P": 8.6,
    "S": 5.2
  },
  {
    "odds": "10-1",
    "W": 23.2,
    "P": 9.4,
    "S": 5.4
  },
  {
    "odds": "11-1",
    "W": 24.8,
    "P": 9.8,
    "S": 5.8
  },
  {
    "odds": "12-1",
    "W": 26.8,
    "P": 10.6,
    "S": 6
  },
  {
    "odds": "13-1",
    "W": 28.8,
    "P": 11.2,
    "S": 6.2
  },
  {
    "odds": "14-1",
    "W": 30.8,
    "P": 11.8,
    "S": 6.4
  },
  {
    "odds": "15-1",
    "W": 32.8,
    "P": 12.4,
    "S": 6.8
  },
  {
    "odds": "16-1",
    "W": 34.8,
    "P": 13,
    "S": 7
  },
  {
    "odds": "17-1",
    "W": 36.8,
    "P": 13.8,
    "S": 7.4
  },
  {
    "odds": "18-1",
    "W": 38.8,
    "P": 14.6,
    "S": 7.6
  },
  {
    "odds": "19-1",
    "W": 40.8,
    "P": 15,
    "S": 7.6
  },
  {
    "odds": "20-1",
    "W": 42.8,
    "P": 15.8,
    "S": 8.2
  },
  {
    "odds": "20/1+",
    "W": 70.34,
    "P": 24.11,
    "S": 10.6
  }
];

export default averageWPSScores;
